var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getShowBool())?_c('div',[_c('a',{attrs:{"href":_vm.createSamTechUrl(_vm.row)}},[_vm._v(" "+_vm._s(_vm.getSamTechVehicle(_vm.row.VechicleId))+" #"+_vm._s(_vm.row.VechicleId)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }